/**
 * Iter 234 — i18n setup avec react-i18next.
 * Langues : FR (default), EN, ES.
 * Stratégie pragmatique : namespaces par feature pour éviter un fichier monstre.
 */
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import frCommon from "./locales/fr/common.json";
import enCommon from "./locales/en/common.json";
import esCommon from "./locales/es/common.json";
import ptCommon from "./locales/pt/common.json";

export const LANGUAGES = [
  { code: "fr", flag: "🇫🇷", label: "Français" },
  { code: "en", flag: "🇬🇧", label: "English" },
  { code: "es", flag: "🇪🇸", label: "Español" },
  { code: "pt", flag: "🇵🇹", label: "Português" },
];

// Iter 355 — apps de bureau : ?lang=xx (écran d'accueil) fixe la langue avant l'initialisation
try {
  const qlang = new URLSearchParams(window.location.search).get("lang");
  if (qlang && ["fr", "en", "es", "pt"].includes(qlang)) localStorage.setItem("blitzz_lang", qlang);
} catch (_) {}

const resources = {
  fr: { common: frCommon },
  en: { common: enCommon },
  es: { common: esCommon },
  pt: { common: ptCommon },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: "fr",
    lng: undefined,  // Iter 235c — Laisse LanguageDetector décider, mais le détecteur ne regarde plus navigator
    supportedLngs: ["fr", "en", "es", "pt"],
    load: "languageOnly",
    defaultNS: "common",
    ns: ["common"],
    interpolation: { escapeValue: false },
    detection: {
      // Iter 235c — ON RETIRE `navigator` pour éviter que les FR avec un navigateur EN voient la version EN.
      // L'utilisateur peut basculer manuellement via le `LanguageSwitcher`.
      order: ["localStorage", "navigator"],  // Iter 354 — langue du navigateur au premier accès, puis choix mémorisé (profil + localStorage)
      caches: ["localStorage"],
      lookupLocalStorage: "blitzz_lang",
    },
  });

export default i18n;
